import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React, { useContext } from 'react';
import { useParams } from 'react-router';

import Page from '@feathr/extender/App/Page';
import { StoresContext } from '@feathr/extender/state';

import PersonIcon from '../PersonColumns/PersonIcon';
import PersonDetail from './PersonDetail';

import * as styles from './PersonDetail.css';

function PersonPage(): JSX.Element {
  const { Persons } = useContext(StoresContext);
  const { personId } = useParams<{ personId: string }>();
  const person = Persons.get(personId);

  if (!person.isPending && person.get('companies') && !Array.isArray(person.get('companies'))) {
    person.set({ companies: ([] as string[]).concat(person.get('companies')) });
  }
  return (
    <Page
      loading={person.isPending}
      title={
        <>
          <span className={styles.title}>
            <PersonIcon person={person.toJS()} /> {person.name}
          </span>
        </>
      }
    >
      <PersonDetail person={person} />
    </Page>
  );
}

export default observer(PersonPage);
